(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-happy-customers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const proof = document.querySelector('[data-review-proof]');
    if (!proof) return;
    const update = () => {
      const widget = document.querySelector('.jdgm-rev-widg[data-average-rating][data-number-of-reviews], [data-average-rating][data-number-of-reviews]');
      const grid = document.querySelector('.jdgm-reviews-grid-widget');
      if (!widget && !grid) return false;
      let count = Number(widget?.dataset.numberOfReviews || 0);
      let average = Number(widget?.dataset.averageRating || 0);
      if ((!count || !average) && grid) {
        const headerText = grid.querySelector('.jm-grid-header')?.textContent || '';
        const countMatch = headerText.match(/\(([\d,]+)\)/);
        const ratingLabel = grid.querySelector('.jm-star-rating')?.getAttribute('aria-label') || '';
        const ratingMatch = ratingLabel.match(/[\d.]+/);
        count = Number((countMatch?.[1] || '').replace(/,/g, ''));
        average = Number(ratingMatch?.[0] || 0);
      }
      if (count < 1) return false;
      proof.querySelector('[data-review-average]').textContent = average.toFixed(2).replace(/0$/, '');
      proof.querySelector('[data-review-count]').textContent = count.toLocaleString();
      proof.querySelector('.wm-notes-stars').setAttribute('aria-label', `${average.toFixed(1)} out of 5 from ${count} ratings`);
      return true;
    };
    if (!update()) {
      const observer = new MutationObserver(() => { if (update()) observer.disconnect(); });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 12000);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-hero"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('westmere-index'))customElements.define('westmere-index',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;const list=this.querySelector('[role="tablist"]');const media=matchMedia('(max-width:900px)');const orient=()=>list.setAttribute('aria-orientation',media.matches?'horizontal':'vertical');orient();media.addEventListener('change',orient);const tabs=[...this.querySelectorAll('[role="tab"]')];const panels=[...this.querySelectorAll('[role="tabpanel"]')];const choose=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});if(focus)tabs[index].focus()};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>choose(index));tab.addEventListener('keydown',event=>{let next=index;if(['ArrowRight','ArrowDown'].includes(event.key))next=(index+1)%tabs.length;else if(['ArrowLeft','ArrowUp'].includes(event.key))next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();choose(next,true)})});this.addEventListener('shopify:block:select',event=>{const index=tabs.findIndex(tab=>tab.contains(event.target)||tab===event.target);if(index>=0)choose(index)})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-our-story"]) return;
  try {
    
  document.querySelectorAll('.wm-story-gallery').forEach(gallery=>{
    const dialog=gallery.querySelector('dialog');
    gallery.querySelectorAll('[data-gallery-image]').forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();const source=link.querySelector('img');const image=dialog.querySelector('img');image.src=link.href;image.alt=source.alt;dialog.querySelector('p').textContent=source.alt;dialog.showModal();
    }));
    dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}});
  });

  } catch(e) { console.error(e); }
})();
})();
